module.exports = __webpack_public_path__ + "assets/icons/insights-logo.cc61aa077a91ddc3784398e0424506c3.svg";